var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.Utilities = OCS.Interfaces.Utilities || {};
OCS.Interfaces.Utilities.base = {
    isNumber: function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    },
    isInteger: function (value) {
        return typeof value === "number" && this.isNumber(value) && isFinite(value) && Math.floor(value) === value;
    },
    is_undefined: function (val) {
        if (typeof val === "undefined") {
            return true;
        } else {
            return false;
        }
    },
    is_null: function (val) {
        if (val === null && typeof val === "object") {
            return true;
        } else {
            return false;
        }
    },
    is_boolean: function (val)  {
        return typeof val === 'boolean';
    },
    is_array: function (val) {
        return val instanceof Array;
    },
    is_string: function (val) {
        if (typeof val === 'string' || val instanceof String) {
            return true;
        } else {
            return false;
        }
    },
    is_object: function (val) {
        if (!this.is_null(val) && typeof val === "object") {
            return true;
        } else {
            return false;
        }
    },
    is_empty: function (obj) {
        if (this.is_array(obj) && !obj.length) {
            return true;
        }
        if (this.is_object(obj) && !Object.keys(obj).length) {
            return true;
        }
        return false;
    },
    parse_item_or_list: function (data, callback) {
        if (this.is_array(data) || this.is_object(data)) {
            Object.each(data, function (d) {
                callback(d);
            });
        } else {
            callback(data);
        }
    },
    create_throttled_method: function (callback, wait, ops) {
        var first = true;
        var stored_timeout;
        return function (callback_data, callback_ops) {
            if (!stored_timeout) {
                if (!ops || !ops.hasOwnProperty('leading') || ops.leading || !first) {
                    callback(callback_data, callback_ops);
                }
                stored_timeout = setTimeout(function () {
                    stored_timeout = null;
                }.bind(this), wait);
                first = false;
            }
        };
    },
    create_debounced_method: function (callback, wait, ops) {
        var stored_timeout;
        return function (callback_data, callback_ops) {
            if (stored_timeout) {
                clearTimeout(stored_timeout);
            }
            stored_timeout = setTimeout(function () {
                callback(callback_data, callback_ops);
                stored_timeout = null;
            }.bind(this), wait);
        };
    },
    get_watched_counties: function () {
        console.warn("OCS Utilities: get_watched_counties is DEPRECATED!");
        return Object.keys(this.get_watched_counties_objs());
    },
    get_watched_counties_objs: function () {
        console.warn("OCS Utilities: get_watched_counties_objs is DEPRECATED!");
        if (OCS.Constants && OCS.Constants.WATCHED_COUNTIES_OBJS) {
            return OCS.Constants.WATCHED_COUNTIES_OBJS;
        } else {
            return {};
        }
    },
    get_county_object_with_id: function (id) {
        console.warn("OCS Utilities: get_county_object_with_id is DEPRECATED!");
        var county_obj;
        var watched_counties = this.get_watched_counties_objs();

        if (watched_counties[id.toUpperCase()]) {
            county_obj = OCS.Constants.WATCHED_COUNTIES_OBJS[id.toUpperCase()];
        }
        return county_obj;
    },
    xml_string_to_xml: function (str) {
        var oParser = new DOMParser();
        return oParser.parseFromString(str, "text/xml");
    },
    xml_to_json: function (xml, ops) {

        // Create the return object
        var obj = {};

        if (xml.nodeType === 1) { // element
            // do attributes
            if (xml.attributes.length > 0) {
                obj["@attributes"] = {};
                for (var j = 0; j < xml.attributes.length; j++) {
                    var attribute = xml.attributes.item(j);
                    obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
                }
            }
        } else if (xml.nodeType === 3) { // text
            obj = xml.nodeValue;
        }

        // do children
        if (xml.hasChildNodes()) {
            var saved_index = 0;
            for (var i = 0; i < xml.childNodes.length; i++) {
                var item = xml.childNodes.item(i);
                var nodeName = item.nodeName;
                if (ops && ops.no_text && nodeName === '#text') {
                    continue;
                }
                var result1 = this.xml_to_json(item, ops);
                if (result1 && this.is_object(result1) && Object.keys(result1).length) {
                    result1.$index = saved_index;
                    saved_index++; // Increment the saved index forward since we have now used it
                    if (typeof (obj[nodeName]) === "undefined") {
                        obj[nodeName] = result1;
                    } else {
                        if (typeof (obj[nodeName].push) === "undefined") {
                            var old = obj[nodeName];
                            obj[nodeName] = [];
                            obj[nodeName].push(old);
                        }

                        obj[nodeName].push(result1);
                    }
                }
            }
        }
        return obj;
    }
};